// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import iconFactory from 'syft-acp-atoms/Icons'

import './IconCheckCircle.css'

const IconCheckCircle = ({ tooltipID, testID }: { tooltipID: string; testID: string }) => {
  const IconFactory = iconFactory('check', 'Allowed')
  return (
    <a data-for={tooltipID} data-testid={testID} data-tip>
      <IconFactory fill="white" className="checkCircleIcon" iconSize={10} />
    </a>
  )
}
export default IconCheckCircle
